// Script pour modifier les textes natifs Shopify des options de livraison/retrait
(function() {
  'use strict';

  // Fonction pour modifier le texte "Retrait en boutique"
  function modifyPickupLabel() {
    // Chercher tous les labels ou textes contenant "Retrait en boutique"
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    let node;
    while (node = walker.nextNode()) {
      const text = node.textContent.trim();
      // Modifier "Retrait en boutique" par votre texte personnalisé
      if (text === 'Retrait en boutique' || text.includes('Retrait en boutique')) {
        node.textContent = node.textContent.replace(/Retrait en boutique/gi, 'Retrait sur place à la Bourse Aux Reptiles');
      }
    }

    // Chercher aussi dans les éléments avec des attributs spécifiques (radio buttons, labels)
    const labels = document.querySelectorAll('label, span, div, p');
    labels.forEach(element => {
      if (element.textContent && element.textContent.includes('Retrait en boutique')) {
        element.textContent = element.textContent.replace(/Retrait en boutique/gi, 'Retrait sur place à la Bourse Aux Reptiles');
      }
    });
  }

  // Fonction pour supprimer le message "Les emplacements les plus proches..."
  function hideLocationDistanceMessage() {
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    let node;
    while (node = walker.nextNode()) {
      const text = node.textContent.trim();
      // Chercher le message sur les emplacements
      if (text.includes('Les emplacements les plus proches se situent à plus de') || 
          text.includes('emplacements les plus proches se situent à plus de')) {
        // Trouver l'élément parent et le masquer
        let parent = node.parentElement;
        let depth = 0;
        while (parent && depth < 5) {
          // Chercher un conteneur avec une classe ou un ID significatif
          if (parent.classList.length > 0 || parent.id) {
            parent.style.display = 'none';
            break;
          }
          parent = parent.parentElement;
          depth++;
        }
      }
    }

    // Chercher aussi dans les éléments visuels (boîtes d'info, alertes)
    const infoElements = document.querySelectorAll('[class*="info"], [class*="alert"], [class*="message"], [class*="notice"]');
    infoElements.forEach(element => {
      const text = element.textContent || '';
      if (text.includes('emplacements les plus proches se situent à plus de') ||
          text.includes('Les emplacements les plus proches se situent à plus de')) {
        element.style.display = 'none';
      }
    });
  }

  // Fonction principale qui s'exécute immédiatement et avec un observer
  function applyModifications() {
    modifyPickupLabel();
    hideLocationDistanceMessage();
  }

  // Exécuter immédiatement si le DOM est déjà chargé
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyModifications);
  } else {
    applyModifications();
  }

  // Observer pour détecter les changements dynamiques du DOM (Shopify modifie souvent le DOM)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        // Attendre un peu pour que Shopify termine ses modifications
        setTimeout(applyModifications, 100);
      }
    });
  });

  // Observer le body pour les changements
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Ré-exécuter périodiquement pour capturer les modifications tardives
  setInterval(applyModifications, 500);
})();
